import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

import { validateOrderId } from "@/app/routeValidation";
import FlightBookSuccess from "@/features/flights/components/flight-purchase/FlightBookSuccess";
import { useFlightSelectionPayloadContext } from "@/features/flights/contexts/FlightSelectionPayloadContext/FlightSelectionPayloadContext";
import { useSelectedDepartureFlight } from "@/features/flights/hooks/flightSearch/useSelectedDepartureFlight";
import { useSelectedReturnFlight } from "@/features/flights/hooks/flightSearch/useSelectedReturnFlight";
import { flightAvailabilityQueryOptions } from "@/features/flights/hooks/useFlightAvailability";
import { useTravellersSelectionContext } from "@/features/travellers/contexts/TravellersSelectionContext";

export const Route = createFileRoute(
  "/_authenticated/flights/_offers/offer/$id/confirmation",
)({
  validateSearch: validateOrderId,
  component: RouteComponent,
  staticData: {
    drawer: false,
  },
});

function RouteComponent() {
  const { orderId } = Route.useSearch();

  const { selectedFlightPayload } = useFlightSelectionPayloadContext();
  const { result: selectedDepartureFlight } = useSelectedDepartureFlight();
  const { result: selectedReturnFlight } = useSelectedReturnFlight();
  const { data: singleFlightDetails } = useQuery(
    flightAvailabilityQueryOptions(selectedFlightPayload),
  );

  const { selectedTravellers } = useTravellersSelectionContext();

  return (
    <FlightBookSuccess
      singleFlightDetails={singleFlightDetails}
      departureFlight={selectedDepartureFlight}
      returnFlight={selectedReturnFlight}
      departureStops={selectedDepartureFlight?.stops || []}
      returnStops={selectedReturnFlight?.stops || []}
      selectedTravellers={selectedTravellers}
      orderId={orderId}
    />
  );
}
